import IssuerListContainer from '../helpers/IssuerListContainer';

class OpenBankingUKElement extends IssuerListContainer {
    public static type = 'openbanking_UK';
}

export default OpenBankingUKElement;
